import { IKnmKnoOrganizationFunction } from 'APIPackage/KnmModule/interfaces/IKnmKnoOrganizationFunction';

import { IKnmKnoOrganizationFunctionSelectOption } from '../interfaces/IKnmKnoOrganizationFunctionSelectOption';

export const createKnmKnoOrganizationFunctionSelectOption = (
  knmKnoOrganizationFunction: IKnmKnoOrganizationFunction,
): IKnmKnoOrganizationFunctionSelectOption => ({
  ...knmKnoOrganizationFunction,
  label: `(${knmKnoOrganizationFunction.idFrgu}) ${knmKnoOrganizationFunction.fullName}`,
  value: knmKnoOrganizationFunction.id,
});
